import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { unCamelCase } from '../../utils/helpers';
import SideNavigation from '../SideNavigation/SideNavigation'; // Formats the items into an array of categories as expected by SideNavigation

function createCategories(items) {
  if (!items) {
    return [];
  }

  var categoryItems = items.reduce(function (categories, item) {
    var category = item.category || item.type;
    var subCategory = item.subCategory || '';

    if (!categories[category]) {
      var _ref;

      categories[category] = {
        id: category,
        names: [{
          componentName: item.componentName,
          displayName: item.name
        }],
        displayName: unCamelCase(category),
        subCategories: subCategory ? (_ref = {}, _ref[subCategory] = {
          id: subCategory,
          displayName: unCamelCase(subCategory)
        }, _ref) : []
      };
    } else {
      categories[category].names.push({
        componentName: item.componentName,
        displayName: item.name
      });
    }

    if (subCategory && !categories[category].subCategories[subCategory]) {
      categories[category].subCategories[subCategory] = {
        id: subCategory,
        displayName: unCamelCase(subCategory)
      };
    }

    return categories;
  }, {});
  return Object.keys(categoryItems).map(function (categoryKey) {
    var catItem = categoryItems[categoryKey];
    var subCategories = catItem.subCategories;
    catItem.subCategories = Object.keys(subCategories).map(function (subKey) {
      return subCategories[subKey];
    });
    return catItem;
  });
}

function SideNavigationLocal(props) {
  var category = props.category,
      family = props.family,
      items = props.items,
      localSearchComponent = props.localSearchComponent,
      name = props.name,
      onClick = props.onClick,
      subCategory = props.subCategory,
      prefix = props.prefix,
      search = props.search;
  var repoName = Array.isArray(items) && items.length >= 1 ? items[0].repoData.name : '';

  function renderOrder(_ref2) {
    var currentCategory = _ref2.currentCategory,
        handleNavClick = _ref2.handleNavClick,
        currentName = _ref2.name;
    var id = currentCategory.id,
        names = currentCategory.names;
    return names.map(function (_ref3) {
      var componentName = _ref3.componentName,
          itemName = _ref3.displayName;
      var itemClasses = classnames('SideNavigation__item', {
        'SideNavigation__item--current': itemName === currentName
      });
      var componentHref = localSearchComponent ? prefix + "/" + repoName + "/" + (componentName || itemName) + search : '#';
      return /*#__PURE__*/React.createElement("li", {
        key: "link_" + itemName
      }, /*#__PURE__*/React.createElement("a", {
        href: componentHref,
        className: itemClasses,
        "data-component-name": componentName,
        "data-name": itemName,
        "data-repo-name": repoName,
        "data-category": id,
        "data-family": family,
        onClick: handleNavClick
      }, itemName));
    });
  }

  var categories = createCategories(items);
  var familyDisplayName = unCamelCase(family);
  return /*#__PURE__*/React.createElement(SideNavigation, {
    family: family,
    familyDisplayName: familyDisplayName,
    categories: categories,
    category: category,
    localSearchComponent: localSearchComponent,
    name: name,
    onClick: onClick,
    renderOrder: renderOrder,
    subCategory: subCategory
  });
}

SideNavigationLocal.propTypes = {
  /** Category of the currently viewed component. */
  category: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    componentName: PropTypes.string,
    family: PropTypes.string,
    category: PropTypes.string,
    subcategory: PropTypes.string,
    name: PropTypes.string,
    repoData: PropTypes.shape({
      name: PropTypes.string
    }),
    type: PropTypes.string
  })).isRequired,

  /** Family of the currently viewed component. */
  family: PropTypes.string.isRequired,

  /** Repo name of the currently viewed component. */
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func,

  /** React component for rendering local search. */
  localSearchComponent: PropTypes.element,

  /** URL prefix. **/
  prefix: PropTypes.string,

  /** window.location.search value. **/
  search: PropTypes.string,

  /** Currently selected sub category. */
  subCategory: PropTypes.string
};
SideNavigationLocal.defaultProps = {
  /* istanbul ignore next */
  onClick:
  /* istanbul ignore next */
  function onClick() {},
  prefix: '',
  search: ''
};
export default SideNavigationLocal;
//# sourceMappingURL=SideNavigationLocal.js.map